"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormData = require('form-data');
class TransactionRepository {
    fetcherAmplify;
    fetcherAxios;
    constructor(fetcherAmplify, fetcherAxios) {
        this.fetcherAmplify = fetcherAmplify;
        this.fetcherAxios = fetcherAxios;
    }
    async saveFile(url, fields, file) {
        const formData = new FormData();
        const keys = [
            'Content-Type',
            'key',
            'bucket',
            'X-Amz-Algorithm',
            'X-Amz-Credential',
            'X-Amz-Date',
            'X-Amz-Security-Token',
            'Policy',
            'X-Amz-Signature',
        ];
        keys.forEach((name) => {
            formData.append(name, fields[name]);
        });
        formData.append('file', file);
        return this.fetcherAxios.post(url, formData);
    }
    async subscribe({ customer, data, image, blumAnalyticsId, }) {
        const dataRequest = {
            type: 'BUY',
            amount: data.amount,
            currency: data.currency,
            origin: {
                bank: { id: data.bankId, transaction: {} },
            },
            fund: {
                id: data.fundId,
                series: data.series,
            },
            ...(data.goalId && {
                destiny: {
                    goal: {
                        id: data.goalId,
                        fund: {
                            id: data.fundId,
                            series: data.series,
                        },
                    },
                },
            }),
        };
        if (data.voucher) {
            dataRequest.voucher = {
                id: data.voucher,
            };
        }
        if (data.numberTicket) {
            dataRequest.origin.bank.transaction = {
                id: data.numberTicket,
            };
        }
        if (data.imageTicket) {
            dataRequest.origin.bank.transaction.voucher = {
                contentType: data.imageTicket,
            };
        }
        const response = await this.fetcherAmplify.post('/v1/transactions', {
            body: dataRequest,
            headers: {
                'Blum-Analytics-Id': blumAnalyticsId,
            },
            ...(customer && {
                queryStringParameters: {
                    customerId: customer?.id,
                    customerType: customer?.type,
                },
            }),
        });
        if (response?.origin?.bank?.transaction?.voucher?.upload && image) {
            const { url, fields } = response?.origin?.bank?.transaction?.voucher?.upload;
            await this.saveFile(url, fields, image);
        }
        return response;
    }
    async rescue(data) {
        const isPartial = data.subType === 'PARTIAL';
        const dataRequest = {
            type: 'SELL',
            subType: data.subType,
            ...(isPartial && {
                shares: data?.shares,
                amount: data?.amount,
            }),
            creationDate: data.creationDate,
            currency: data.currency,
            ...(data.customer?.type === 'INDIVIDUAL' && {
                otp: { id: data.otpId },
            }),
            fund: {
                id: data.fundId,
                series: data.series,
            },
            destiny: { account: { id: data.accountId } },
        };
        return this.fetcherAmplify.post('/v1/transactions', {
            queryStringParameters: {
                ...(data.customer?.id && {
                    customerId: data.customer?.id,
                    customerType: data.customer?.type,
                }),
            },
            body: dataRequest,
        });
    }
    async fundSwitch(data) {
        const dataRequest = {
            type: 'FUNDSWITCH',
            subType: data.subType,
            amount: data.amount,
            currency: data.currency,
            origin: {
                fund: {
                    id: data.origin.fund.id,
                    series: data.origin.fund.series,
                },
            },
            destiny: {
                fund: {
                    id: data.destiny.fund.id,
                    series: data.destiny.fund.series,
                },
            },
        };
        return this.fetcherAmplify.post('/v1/transactions', {
            queryStringParameters: {
                ...(data.customer?.id && {
                    customerId: data.customer?.id,
                    customerType: data.customer?.type,
                }),
            },
            body: dataRequest,
        });
    }
    async findTransactions(params) {
        const queryStringParameters = {
            onlyInProgress: params.onlyInProgress,
            ...(params.goalId && { goalId: params.goalId }),
            ...(params.filters && params.filters),
        };
        const data = await this.fetcherAmplify.get('/v1/transactions', {
            queryStringParameters,
        });
        if (!data)
            return [];
        return data;
    }
    async approvalTransaction(transactionId, status, customer) {
        return this.fetcherAmplify.put(`/v1/transactions/${transactionId}/approvals`, {
            body: {
                status,
            },
            queryStringParameters: {
                ...(customer && {
                    customerId: customer?.id,
                    customerType: customer?.type,
                }),
            },
        });
    }
}
exports.default = TransactionRepository;
//# sourceMappingURL=TransactionRepositoryImpl.js.map